import type { PiiLookupDocumentDto } from "@babackapp/private-api-client/generated/schema";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@babackapp/ui/components/dialog";
import { Textarea } from "@babackapp/ui/components/textarea";

/** Debug only: raw comparison payload for one document, as JSON. */
export function PiiDocumentJsonDialog({
  document,
  trigger,
}: {
  document: PiiLookupDocumentDto;
  trigger: React.ReactNode;
}) {
  return (
    <Dialog>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>
            {document.kind} · {document.reference}
          </DialogTitle>
        </DialogHeader>
        <Textarea
          readOnly
          value={JSON.stringify(document, null, 2)}
          className="font-mono text-xs h-[60vh]"
        />
      </DialogContent>
    </Dialog>
  );
}
